import React, { useState } from 'react'
import {
  GalleryIconWrapper,
  SendIconWrapper,
  StyleInput,
  StyleMessageInputWrapper,
  UploadInput,
} from '../style'
import { Field, Form, Formik } from 'formik'

import { gallery, send } from '@assets/icons'
import {
  ImagePreviewWrapper,
  StyleImagePreview,
  StyleImagePreviewContainer,
} from './style'
import { fileToBase64WithExtension, UploadedImage } from '@utils/fileToBase64'
import { format } from 'date-fns'
import { useDispatch } from 'react-redux'
import { Actions } from '@store/index'
import Svg from '@components/svg'
import useIsMobile from '@hooks/useIsMobile'

const MessageInputField = () => {
  const isMobile = useIsMobile()
  const dispatch = useDispatch()
  const [uploadedImages, setUploadedImages] = useState<UploadedImage[]>([])
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files
    if (!files) return
    const promises = Array.from(files).map(fileToBase64WithExtension)
    const results = await Promise.all(promises)
    setUploadedImages(results)
  }
  const handleSend = (values: { message: string }, { resetForm }: any) => {
    if (!values.message.trim() && uploadedImages.length === 0) {
      // toast.error('Please enter a message or attach an image before sending.')
      return
    }
    const newMessage = {
      senderId: '0',
      receiverId: '1',
      message: values.message,
      time: format(new Date(), 'hh:mm a'),
      imgsrc: uploadedImages.map(({ base64 }) => base64),
    }
    dispatch(Actions.append('supportMessages', newMessage))

    if (uploadedImages.length > 0) {
    }
    resetForm()
    setUploadedImages([])
  }

  return (
    <>
      {uploadedImages.length > 0 && (
        <StyleImagePreviewContainer>
          {uploadedImages.map(({ base64 }, idx) => (
            <ImagePreviewWrapper key={idx}>
              <StyleImagePreview src={base64} />
            </ImagePreviewWrapper>
          ))}
        </StyleImagePreviewContainer>
      )}
      <Formik initialValues={{ message: '' }} onSubmit={handleSend}>
        {({ handleSubmit }) => (
          <Form>
            <StyleMessageInputWrapper>
              <Field
                as={StyleInput}
                name="message"
                type="text"
                placeholder="Type your message here"
              />
              <GalleryIconWrapper htmlFor="upload-image">
                <Svg src={gallery} />
              </GalleryIconWrapper>
              <SendIconWrapper onClick={() => handleSubmit()}>
                <Svg src={send} />
              </SendIconWrapper>
            </StyleMessageInputWrapper>

            <UploadInput
              id="upload-image"
              type="file"
              multiple
              onChange={handleFileChange}
            />
          </Form>
        )}
      </Formik>
    </>
  )
}

export default MessageInputField
